<template>
  <div class="content">
    <div class="banner-sub">
      <img :src="bannerImg" alt="">
    </div>
    <div class="wrap contact2">
      <div class="box1">
        <h2 class="h2">各地联系方式</h2>
        <div class="item" v-for="(item, idx) in contactList" :key="idx">
          <strong>{{item.name}}</strong>
          <span>{{ item.address}}</span>
          <span>电话：{{ item.phone}}</span>
        </div>
        <!-- <div class="item">
          <strong>南宁总部</strong>
          <span>广西南宁市青秀区桂雅路11号凤岭麒麟商户大厦</span>
          <span>电话：86-0771-5739&nbsp;586</span>
        </div> -->
      </div>
      <div class="box2">
        <h2 class="h2">招聘</h2>
        <div class="item" v-for="(item, idx) in emailList" :key="idx">
          <strong>{{item.name}}</strong>
          <span>{{ item.email}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiWebConcatList, ApiWebBackdropImg } from '../api/concat'
export default {
  name: 'contact',
  data () {
    return {
      contactList: [],
      emailList: [],
      // 顶部和底部背景图片
      bannerImg: ''
    }
  },
  created () {
    this.getContactListHandler()
    this.getEmailListHandler()
    this.topbackground()
  },
  methods: {
    // 获取背景图片url
    topbackground() {
      ApiWebBackdropImg().then(({ data }) => {
        if (data && data.status === 0) {
          this.bannerImg = data.data.topImg
        }
      })
    },
    getContactListHandler() {
      let obj = {
        'type': 2 // 类型 1-招聘信息、2-各地联系方式
      }
      ApiWebConcatList(obj).then(({ data }) => {
        if (data && data.status === 0) {
          this.contactList = data.data.list
        }
      })
    },
    getEmailListHandler() {
      let obj = {
        'type': 1 // 类型 1-招聘信息、2-各地联系方式
      }
      ApiWebConcatList(obj).then(({ data }) => {
        if (data && data.status === 0) {
          this.emailList = data.data.list
        }
      })

    },
  }
}
</script>

<style scoped lang="less">
  @import '../assets/style/index.less';
  .contact2{
    display: flex;
    .box1,.box2{
      flex: 1;
      margin-bottom: 75px;
      .h2{
        width: 100%;
        height: 58px;
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        margin-top: 74px;
        margin-bottom: 74px;
        position: relative;
        &::before{
          display: block;
          content: ' ';
          width: 72px;
          height: 2px;
          background: #DC252B;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
      .item{
        padding-left: 24px;
        margin-top: 38px;
        strong{
          height: 20px;
          overflow-wrap: break-word;
          color: rgba(51, 51, 51, 1);
          font-size: 20px;
          font-family: MicrosoftYaHei-Bold;
          text-align: left;
          white-space: nowrap;
          line-height: 20px;
          display: block;
          margin-bottom: 35px;
        }
        span{
          line-height: 20px;
          overflow-wrap: break-word;
          color: rgba(102, 102, 102, 1);
          font-size: 20px;
          font-family: MicrosoftYaHei;
          text-align: left;
          white-space: nowrap;
          display: block;
          margin-bottom: 22px;
        }
      }
    }
    .box1{
      margin-right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/contact.vue